import { NavLink, Outlet } from 'react-router-dom';
import './style.scss';
import RequestVerificationTokenInput from '../../Shared/RequestVerificationTokenInput';

export default function PrivateCustomer() {
  return (
    <div>
      <nav className="mitt-konto-private-customer__nav">
        <NavLink to="mina-uppgifter">Mina uppgifter</NavLink>
        <NavLink to="mina-erbjudanden">Mina erbjudanden</NavLink>
        <NavLink to="mina-biljetter">Mina biljetter</NavLink>
        {/* Temporarily logout function to make it easier to test */}
        <form action="/konto/logga-ut" method="post">
          <RequestVerificationTokenInput />
          <button type="submit" className="btn btn-link p-0">
            Logga ut
          </button>
        </form>
      </nav>
      <div className="mitt-konto-private-customer__content">
        <Outlet />
      </div>
    </div>
  );
}
